import styled from 'styled-components';
import { variant, width } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { ButtonProps } from '../Button';
import { getDefaultEmphasisVariant } from '../util/getDefaultEmphasisVariant';
import { getDestructiveEmphasisVariant } from '../util/getDestructiveEmphasisVariant';

export const StyledButton = styled.button<ButtonProps>`
    appearance: none;
    position: relative;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;

    cursor: pointer;

    color: ${theme.colors.foreground.default};
    font-weight: ${theme.fontWeights[500]};
    font-size: 14px;

    border: none;
    border-radius: 6px;

    white-space: nowrap;

    ${width};

    ${variant({
        prop: 'size',
        variants: {
            small: {
                fontSize: '12px',
                lineHeight: '16px',
            },
            medium: {
                fontSize: '14px',
                lineHeight: '24px',
            },
        },
    })}

    ${(props) => (props.destructive ? getDestructiveEmphasisVariant() : getDefaultEmphasisVariant())}

    &:disabled {
        ${variant({
            prop: 'emphasis',
            variants: {
                high: {
                    color: theme.colors.foreground.onEmphasis,
                },
                medium: {
                    background: `linear-gradient(0deg, ${theme.colors.background.subtle} 0%, ${theme.colors.background.default} 100%)`,
                    color: theme.colors.foreground.disabled,
                    boxShadow: `${theme.shadows.border.default}`,
                },
                low: {
                    color: theme.colors.foreground.disabled,
                    background: theme.colors.background.default,
                },
                none: {
                    color: theme.colors.foreground.disabled,
                    background: theme.colors.background.default,
                },
            },
        })}
    }

    // Reset styles in case button is rendered as a link
    &:hover,
    &:focus {
        text-decoration: none;
    }
`;
